import "./FeesAndCharges.css";

import React from "react";

import { InfoItem } from "components/pf";
import { LinkButton } from "components/buttons";
import { handleOpenPdf } from "utils";

const FeesAndCharges = ({
  title = "Apply easily",
  content = "",
  documents = [
    {
      text: "Latest <b>EPF statement</b>",
      backgroundColor: "#DCE9FF",
    },
    {
      text: "Latest <b>3 months salary slip</b> and personal bank statement reflecting salary crediting",
      backgroundColor: "#F2F4F7",
    },
  ],
  buttons = [
    {
      title: "Product Disclosure Sheet",
      link: "",
    },
    {
      title: "Download Application Form",
      link: "",
    },
  ],
}) => {
  return (
    <section className="section about container" id="fees-and-charges">
      <div
        className="row align-items-center"
        data-aos="fade-up"
        data-aos-delay="200"
      >
        <div className="col-md-4 order-lg-1 order-2 img-fluid-pf">
          <img
            src={"https://www.alrajhibank.com.my/assets/images/pf/alia.svg"}
            alt="Rates and charges"
            className="img-fluid-pf"
          />
        </div>
        <div
          className="col-md-8 order-lg-2 order-1"
          data-aos="zoom-in"
          data-aos-delay="200"
        >
          <div className="pf-rates pb-4">
            <span>{title}</span>
          </div>
          <div className="row">
            {documents.map((item, index) => (
              <InfoItem header={item.title} subheader={item.content} />
            ))}
          </div>
          <div className="link-button-row pt-5">
            {buttons.map((item, index) => (
              <LinkButton
                key={index}
                text={item.title}
                onClick={() => handleOpenPdf(item.link)}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeesAndCharges;
